import {
  EnvironmentInfoProps,
  PageInfoProps,
  CustomerInfoProps,
  ProductInfoProps,
  ProcessInfoProps,
  ObjectInfoProps,
  InsuranceInfoProps,
  EcommerceProps,
} from "./";

interface DataLayerBaseProps {
  event: string;
}

export interface DataLayerProps extends DataLayerBaseProps {
  environmentInfo?: EnvironmentInfoProps;
  pageInfo?: PageInfoProps;
  customerInfo?: CustomerInfoProps;
  insuranceInfo?: InsuranceInfoProps;
  objectInfo?: ObjectInfoProps;
  processInfo?: ProcessInfoProps;
  productInfo?: ProductInfoProps;
  ecommerce?: EcommerceProps;
}

const getDataLayer = () => {
  if (window.self === window.top) {
    return window.dataLayer ?? (window.dataLayer = []);
  } else {
    return window.parent.dataLayer ?? (window.parent.dataLayer = []);
  }
};

const pushDataLayer = (body: DataLayerBaseProps) => {
  getDataLayer().push(body);
};

export { pushDataLayer, getDataLayer };
